import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

export interface PrCheckOut {
  id: string;
  installation_id: number;
  repo_full_name: string;
  pr_number: number;
  pr_head_sha: string;
  pr_title: string | null;
  pr_url: string | null;
  status: 'queued' | 'running' | 'complete' | 'failed' | 'skipped';
  skipped_reason: string | null;
  comment_id: number | null;
  dimensions_run: string[] | null;
  findings_summary_json: {
    new_findings?: number;
    resolved_findings?: number;
    dimensions_run?: string[];
    score_deltas?: Record<string, [number, number]>;
  } | null;
  created_at: string;
  completed_at: string | null;
}

export interface PrCheckListResponse {
  items: PrCheckOut[];
  total: number;
}

export function usePrChecks(limit = 50) {
  return useQuery({
    queryKey: ['pr-checks', { limit }],
    queryFn: () => api<PrCheckListResponse>(`/api/pr-checks?limit=${limit}`),
  });
}

export function usePrCheck(id: string | undefined) {
  return useQuery({
    queryKey: ['pr-check', id],
    queryFn: () => api<PrCheckOut>(`/api/pr-checks/${id}`),
    enabled: Boolean(id),
  });
}
